import commonSetting from "@/config/commonSetting";
import api from "@/services/api/index";
import {Toast} from "antd-mobile";
import { Base64 } from 'js-base64';
import qs from "qs";


const fetchUserInfo = async () => {
  try {
    const resp = await api.userController.usersMeUsingGET();
    let userInfo = resp.data;
    return userInfo
  } catch (error) {
    console.log(error)
    return null
  }
};
const getWxAuthorizationUrl = async ( path, productType, scope) => {
  let params =  {
      productType: productType,
      scope: scope || 'snsapi_base',
      path: path,
      companyType: commonSetting.COMPANY_TYPE
  }
  const resp = await api.wxOauth2Controller.wxOauth2UrlUsingGET(params);
  if(resp.code == 0){
      return resp.data
  }else {
      console.log('授权链接获取失败:',resp.code)
      return null
  }
}

const redirectWxAuthorizationUrl = async (path, productType, scope)=>{
  let url = await getWxAuthorizationUrl(encodeURIComponent(path), productType, scope);
  if(url){
    location.replace(url)
  }else {
    Toast.show({
      icon: 'fail',
      content: '未知错误',
    })
  }
}
// 静态资源路劲
const fileUrlFilter = (url) => {
  if (url) {
    if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
      return url;
    } else {
      return 'https://tj-file-oss.cf69.com/' + url;
    }
  } else {
    return url;
  }
}

const hasKeyInArr = (arr, key, val) =>{
  for (const arrKey in arr) {
    if(arr[arrKey][key] === val){
      return arr[arrKey]
    }
  }
  return false
}

const parseAlign = (columns, direction)=>{
  return columns.map(item=>({...item, align:direction}))
}
const reqUploadTrackEvent = async (category, action, label, _wxId) => {
  let accessToken = localStorage.getItem('accessToken');
  let wxId
  if(accessToken){
    wxId = JSON.parse(Base64.decode(accessToken.split('.')[1]))?.["wxId"]
  }else{
    return
  }
 if(_wxId || wxId){
   let params =  {
     category: category,
     action: action,
     label: label,
     number: localStorage.getItem('salesNumber'),
     wxId: _wxId || wxId
   }
   const resp = await api.wxTrackController.userWxTrackWxIdUsingPOST(params);
   if(resp.code == 0){
     return resp.data
   }else {
     console.log('用户行为追踪:',resp.code)
     return null
   }
 }
}

const reqUploadTrackEventCNZZ = async (category, action, label, linkUrl, $event) => {
  console.log("window._czc",window._czc)
  window._czc && window._czc.push(['_trackEvent', category, action, label])
}
const replaceId = (id) => {
  if (!id) {
    return ''
  }
  const str = `${id}`
  const map = {
    '0': 'J',
    '1': 'A',
    '2': 'B',
    '3': 'C',
    '4': 'D',
    '5': 'E',
    '6': 'F',
    '7': 'G',
    '8': 'H',
    '9': 'I'
  }
  return str.split('').map(item => map[item]).join('')
}
const isWechat = () => {
  //获取user-agaent标识头
  let ua = window.navigator.userAgent.toLowerCase();
  //判断ua和微信浏览器的标识头是否匹配
  if (ua.match(/micromessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}
const customerTrackUpload = async (pageId, category, action, label, salesNumber) => {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    return;
  }
  let params = {
    pageId,  // 页面id
    appId: 'pay',  //应用id
    category,  // 事件
    action,  // 行为
    label,  // 具体描述
    url: window.location.href,  //
    number: salesNumber
  }
  try {
    await api.customerTrackController.userCustomerTrackUploadEnvenUsingPOST(params)
  } catch (error) {
    console.log(error)
  }
}

const customerHeartbeat =  async(pageId) => {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    return;
  }
  let params = {
    pageId,  // 页面id
    appId: 'pay',  //应用id
  }
  try {
    await api.customerTrackController.userCustomerTrackUploadHeartbeatUsingPOST(params)
  } catch (error) {
    console.log(error)
  }


}

const isWeChatPc = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    let system = {
      win: false,
      mac: false
    };
    //检测平台
    const p = navigator.platform;
    system.win = p.indexOf("Win") == 0;
    system.mac = p.indexOf("Mac") == 0;
    if (system.win || system.mac) {
      // alert("在微信PC端上打开内置浏览器");
      return true
    } else {
      // alert("非微信PC端上打开内置浏览器");
      return false
    }
  }else {
    return false
  }
}

// 格式千分位金额
const formatPrice = (price) => {
  // 如果不是整数
  if(!Number.isInteger(price)) {
    price = price.toFixed(2)
  }
  return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const handleCopy = (copyText) => {
    // 创建临时textarea元素
    const textarea = document.createElement('textarea');
    textarea.value = copyText;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);

    // 选择并复制文本
    textarea.select();
    try {
        document.execCommand('copy');
        const dom = document.querySelector('body')
        dom.click()
        Toast.show({
            icon: 'success',
            content: '复制成功',
        });
    } catch (err) {
        Toast.show({
            icon: 'fail',
            content: '复制失败，请手动复制',
        });
    }

    // 清理临时元素
    document.body.removeChild(textarea);
};



const getRootDomain = (hostname) => {
  const domainParts = hostname.split('.');

  if (domainParts.length <= 2) {
    return hostname;
  }

  const tld = domainParts.slice(-2).join('.');
  return tld;
};
const getAuthWxOaRedirectUrl = async (redirectUri, scope) => {
  let params =  {
    category: 'product',
    redirectUri: redirectUri,
    companyType: commonSetting.COMPANY_TYPE,
    scope: scope || 'snsapi_base',
  }
  const resp = await api.authController.authWxOaRedirectUsingGET(params);
  if(resp.code == 0){
    console.log('获取授权链接：',resp.data)
    return resp.data
  }else {
    console.log('授权链接获取失败:',resp.code)
    return null
  }
}
const redirectAuthWxOaRedirect = async (path, scope)=>{
  let url = await getAuthWxOaRedirectUrl(path, scope);
  if(url){
    location.replace(url)
  }else {
    console.error('获取授权链接错误')
  }
}
const getWxMaSchema = (accountType, path, query) => {
  return new Promise(async (resolve, reject) => {
    const resp = await api.pubController.publicWxMaSchemaUsingPOST({
      isExpire: true,
      accountType,
      envVersion: ENV === 'prod' ? 'release' : 'trial',
      path,
      query,
    });
    if (resp?.code === 0) {
      resolve(resp?.data);
    } else {

      reject(resp?.msg);
    }
  });
};

const redirectOtherPage = (baseUrl,redirectPath,source)=>{
  let params = {
    accessToken: localStorage.getItem('accessToken')||'',
    salesId: localStorage.getItem('salesId')||'',
    salesNumber: localStorage.getItem('salesNumber')||'',
    refreshToken: localStorage.getItem('refreshToken') || "",
    source: source||'支付',
    productType: commonSetting.PRODUCT_TYPE
  }
  let query = `params=${encodeURIComponent(JSON.stringify(params))}&open_id=${localStorage.getItem('openId')||''}$wxId=${localStorage.getItem('wxId')||''}`
  window.location.href = baseUrl+`redirect?path=${redirectPath}&${query}`
}


export default {
  redirectOtherPage,
  parseAlign,
  fetchUserInfo,
  reqUploadTrackEventCNZZ,
  reqUploadTrackEvent,
  getWxAuthorizationUrl,
  redirectWxAuthorizationUrl,
  hasKeyInArr,
  fileUrlFilter,
  replaceId,
  customerTrackUpload,
  customerHeartbeat,
  isWechat,
  isWeChatPc,
  formatPrice,
  getRootDomain,
  handleCopy,
  getAuthWxOaRedirectUrl,
  redirectAuthWxOaRedirect,
  getWxMaSchema,
}
